<template>

	<transition name="notification">
		<div class="notification" v-if="showNotification" @click="hideNotification()">
			<div class="container-fluid">
				<div class="d-flex justify-content-start align-items-center">
					<div class="icon"><img src="/images/card/notification-thumb-white.svg"></div>
					<div style="width:calc(100% - 90px;">Få en gratis behandling när du tipsar din kompis.</div>
				</div>
			</div>
		</div>
	</transition>

</template>


<script>
import Cookies from 'js-cookie'

export default {

    data () {
        return {
        	showNotification: false,
        }
    },

    mounted () {

    	// setTimeout(() => {
        //     this.showNotification = true
        // }, 3000)

    },

    methods: {

    	hideNotification(){
    		this.showNotification = false
    		this.$router.push({ name: 'tipsa' })
    	}

    }
}
</script>
<style type="text/css">


/* --- Motification --- */
.notification-enter-active, .notification-leave-active {
    transition: all 500ms;
    transform: translate(0, 0);
}

.notification-enter, .notification-leave-to {
    transform: translate(0, -100%);
}

</style>